import moment from "moment";
import { useState } from "react";

import { BWAFilterOptions } from "../../../types";
import {
  UserInfoExcerptWrapper,
  UserInfoWrapper,
  UserNameWrapper,
  ViewMoreWrapper,
} from "../../common/UserInfoExcerpt/styledComponents";
import useEmailParam from "../../hooks/useEmailParam";

import ArrowRight from "../../../svgs/arrow-right.svg?react";
import UserInfoExcerpt from "../../common/UserInfoExcerpt";
import { UserInfoDrawerSources } from "../../common/UserInfoExcerpt/UserInfoDrawer";
import { ContentWrapper } from "../../common/styledComponents";
import {
  KontaxUserContext,
  useKontaxUserContext,
} from "../../contexts/KontaxUserContext";
import BWAHeader from "./BWAHeader";
import BWAStatsTable from "./BWAStatsTable";

const UserInfo = () => {
  const { user, notes, isLoading } = useKontaxUserContext();

  return (
    <UserInfoExcerpt
      user={user}
      notes={notes}
      source={UserInfoDrawerSources.ACCOUNTING}
      isLoading={isLoading}
      renderExcerptData={(excerptData) => {
        return (
          <UserInfoExcerptWrapper>
            <UserNameWrapper>
              {excerptData.user.firstName} {excerptData.user.lastName}
            </UserNameWrapper>

            <span>
              {excerptData.vatDetails?.isKleinunternehmer && (
                <UserInfoWrapper>Kleinunternehmer</UserInfoWrapper>
              )}
              {excerptData.user.businessTypeComment && (
                <UserInfoWrapper>
                  {excerptData.user.businessTypeComment}
                </UserInfoWrapper>
              )}
              <UserInfoWrapper>
                {excerptData.vatDetails?.frequency} (
                {excerptData.vatDetails?.year})
              </UserInfoWrapper>
              <UserInfoWrapper>{excerptData.notesCount}</UserInfoWrapper>
            </span>

            <ViewMoreWrapper>
              <span>View more info</span>
              <ArrowRight />
            </ViewMoreWrapper>
          </UserInfoExcerptWrapper>
        );
      }}
    />
  );
};

const BWAView = () => {
  const [emailParam, setEmailParam] = useEmailParam();
  const [filterOptions, setFilterOptions] = useState<BWAFilterOptions>({
    email: emailParam || "",
    dateTo: moment().endOf("day").format(),
    dateFrom: moment().startOf("year").format(),
  });

  return (
    <ContentWrapper>
      <BWAHeader
        email={filterOptions.email}
        changeHandler={(updatedFilterOptions: Partial<BWAFilterOptions>) => {
          const newFilterOptions = {
            ...filterOptions,
            ...updatedFilterOptions,
          };
          setFilterOptions(newFilterOptions);
          setEmailParam(newFilterOptions.email || undefined);
        }}
      />
      <KontaxUserContext email={filterOptions.email}>
        <UserInfo />
        <BWAStatsTable filterOptions={filterOptions} />
      </KontaxUserContext>
    </ContentWrapper>
  );
};

export default BWAView;
